import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbDiscount, TbUsersGroup } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";

/** Any row with `passengers[].companions` (plan tasks, hotel clinic tasks, etc.) */
export type PassengerCountRow = {
    passengers?: { companions: { name?: string }[] }[] | null;
};

function PassengerCountColumn({ t }: { t: TFunction }): GridColDef<PassengerCountRow> {
    return {
        field: "passengerCount",
        headerName: t("passengerCount"),
        minWidth: 120,
        flex: 0.2,
        filterable: false,
        valueGetter: (_val, row) =>
            (row.passengers || []).reduce((acc, passenger) => acc + passenger.companions.length + 1, 0),
        renderHeader: (params) => <TableHeader Component={TbDiscount} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <RenderCell value={value} />,
    };
}

function RenderCell({ value }: { value: number }) {
    const status = {
        ...softColors.brown,
        component: () => TbUsersGroup,
        tooltip: {
            title: "Yolcu Sayısı",
            description: `${value} yolcu bulunmaktadır.`,
        },
    };

    return (
        <div className="flex items-center h-full">
            <NoMaxWidthTooltip
                arrow
                sx={{
                    [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: "white",
                        border: "none",
                        padding: "0px !important",
                        fontSize: 12,
                        maxWidth: "200px !important",
                    },
                }}
                title={<HotelStatusTooltip status={status} />}
            >
                <Chip
                    sx={{
                        backgroundColor: "transparent",
                        color: "black",
                        fontWeight: 500,
                    }}
                    icon={createElement(TbUsersGroup, { fontSize: "14", color: "black" })}
                    label={value}
                    size="medium"
                />
            </NoMaxWidthTooltip>
        </div>
    );
}

export default PassengerCountColumn;
